import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["job"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { v4 as uuidV4 } from 'uuid';
import PropTypes from 'prop-types';
import moment from 'moment';
import { viewPermissionSelector, editPermissionSelector } from '../../../common/classes/permissions';
import entityComposition from '../../../common/classes/entityComposition';
const onJobAdd = (props, contentPath, defaults) => {
  const userID = props.userID,
    active = props.job.active,
    change = props.jobActions.change;
  const id = active.id;
  const listItem = _objectSpread({
    id: uuidV4().toUpperCase(),
    appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
    appCreatorID: userID
  }, defaults);
  // Find reference to list
  const subPaths = contentPath.split('/');
  let ref = active;
  subPaths.forEach(subPath => {
    ref = ref[subPath];
  });
  // Add item to list
  ref.push(listItem);
  change(id, contentPath, ref);
};
const onJobRemove = (props, contentPath, removeIndex) => {
  // console.log(`removing ${JSON.stringify(props)}`);
  const active = props.job.active,
    change = props.jobActions.change;
  const id = active.id;
  // Find reference to list
  const subPaths = contentPath.split('/');
  let ref = JSON.parse(JSON.stringify(active));
  subPaths.forEach(subPath => {
    ref = ref[subPath];
  });
  ref.splice(parseInt(removeIndex, 10), 1);
  change(id, subPaths.join('/'), ref);
};
const onJobChangeEvent = (props, contentPath, value) => {
  const active = props.job.active,
    change = props.jobActions.change;
  const id = active.id;
  // Decorate the change event with the job ID
  change(id, contentPath, value);
};
const wrapJobActions = Component => {
  const WrappedComponent = _ref => {
    let _ref$job = _ref.job,
      job = _ref$job === void 0 ? {
        active: {}
      } : _ref$job,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    const active = job.active;
    const bindHandleAdd = (contentPath, defaults) => {
      onJobAdd(_objectSpread({
        job
      }, otherProps), contentPath, defaults);
    };
    const bindHandleRemove = (contentPath, removeIndex) => {
      onJobRemove(_objectSpread({
        job
      }, otherProps), contentPath, removeIndex);
    };
    const bindHandleChangeEvent = (contentPath, value) => {
      onJobChangeEvent(_objectSpread({
        job
      }, otherProps), contentPath, value);
    };
    return /*#__PURE__*/React.createElement(Component, _extends({
      onJobAdd: bindHandleAdd,
      onJobRemove: bindHandleRemove,
      onJobChange: bindHandleChangeEvent,
      active: active,
      job: job
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, otherProps));
  };
  WrappedComponent.propTypes = {
    job: PropTypes.shape({
      active: PropTypes.shape({})
    }),
    canEdit: PropTypes.bool.isRequired,
    canView: PropTypes.bool.isRequired,
    userID: PropTypes.string.isRequired
  };
  return WrappedComponent;
};
const withJobActions = Component => entityComposition(wrapJobActions(Component), ['job', 'jobPiece'], {
  canView: state => viewPermissionSelector('job')(state),
  canEdit: state => editPermissionSelector('job')(state),
  userID: state => state.login.user.user_id,
  activeJob: state => state.job.active
}, ['settings']);
export { wrapJobActions as testWithJobActions };
export default withJobActions;